// extracted by mini-css-extract-plugin
export default {"buttonContainer":"TeamCreateView_buttonContainer__hwNoP"};